export default "__VITE_ASSET__CpEETmkN__"